<script setup>
import { scroll } from "@/core/helpers/scrollTo.js";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

const route = useRoute();
const router = useRouter();
const menuOpen = ref(false);

const scrollTo = (id, routeName) => {
  menuOpen.value = false; // закрываем меню при переходе
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({ name: "home" }).then(() => scroll(id, 300));
  }
};
</script>

<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <router-link :to="{ name: 'home' }">
          <img src="@icons/logo.svg" alt="" />
        </router-link>

        <!-- Кнопка для мобильного меню -->
        <button
            class="header__burger"
            @click="menuOpen = !menuOpen"
            :class="{ active: menuOpen }"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav
            class="header__wrapper-nav"
            :class="{ open: menuOpen }"
        >
          <button @click="scrollTo('about', 'home')">About us</button>
          <button @click="scrollTo('benefits', 'home')">Benefits</button>
          <button @click="scrollTo('contact', 'home')">Contact us</button>
        </nav>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
a {
  display: flex;
}

img {
  cursor: pointer;
}

button {
  cursor: pointer;
  color: #000;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: transparent;
  transition: 0.3s;

  &:hover {
    color: #cda57d;
  }
}

.header {
  position: relative;
  z-index: 10;
  padding-top: 30px;

  @media (max-width: 768px) {
    background-color: rgba(255, 255, 255, 1);
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 50px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

    @media (max-width: 768px) {
      border-radius: unset;
      box-shadow: none;
    }

    &-nav {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 35px;

      @media (max-width: 768px) {
        position: absolute;
        top: 100%;
        right: 0;
        width: 100%;
        flex-direction: column;
        background-color: #fff;
        border-radius: 0 0 20px 20px;
        padding: 20px 0;
        gap: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        opacity: 0;
        pointer-events: none;
        transform: translateY(-10px);
        transition: all 0.3s ease;

        &.open {
          opacity: 1;
          pointer-events: auto;
          transform: translateY(0);
        }
      }
    }
  }

  /* Кнопка-бургер */
  &__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 30px;
    height: 25px;
    border: none;
    background: none;
    cursor: pointer;
    z-index: 11;

    span {
      width: 100%;
      height: 3px;
      background: #000;
      border-radius: 3px;
      transition: 0.3s;
    }

    &.active span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }
    &.active span:nth-child(2) {
      opacity: 0;
    }
    &.active span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }

    @media (max-width: 768px) {
      display: flex;
    }
  }

  @media (max-width: 1024px) {
    .header__wrapper {
      padding: 5px 30px;
      &-nav button {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 768px) {
    padding-top: 20px;

    .header__wrapper {
      padding: 10px 20px;
    }
  }

  @media (max-width: 480px) {
    .header__wrapper-nav button {
      font-size: 16px;
    }
  }
}
</style>
